import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

export const socialData = [
  {
    id: 1,
    icon: <FaFacebook className="icon" />,
    url: "https://www.facebook.com/atapizzakebab",
  },
  {
    id: 2,
    icon: <FaInstagram className="icon" />,
    url: "https://www.instagram.com/atapizza_enghave",
  },
  // {
  // 	id: 3,
  // 	icon: <FaLinkedin className="icon" />,
  // 	url: "https://www.linkedin.com"
  // }
];
